import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import { protoColors } from '../../theme/tokens';

export const Card = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'accent',
})<{ accent: string }>(({ accent }) => ({
  backgroundColor: protoColors.surface,
  border: `1px solid ${protoColors.border}`,
  borderRadius: '16px',
  padding: '18px 20px',
  display: 'flex',
  flexDirection: 'column',
  gap: '14px',
  borderTop: `3px solid ${accent}`,
}));

export const Head = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: '8px',
}));

export const PillarName = styled(Typography)(() => ({
  fontSize: '15px',
  fontWeight: 600,
  color: protoColors.textMuted,
}));

export const Score = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'accent',
})<{ accent: string }>(({ accent }) => ({
  fontSize: '34px',
  fontWeight: 800,
  lineHeight: 1,
  color: accent,
}));

export const MetricRow = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  gap: '12px',
  fontSize: '13px',
  padding: '4px 0',
  borderBottom: `1px solid ${protoColors.surfaceSubtle}`,
}));

export const MetricLabel = styled('span')(() => ({
  color: protoColors.textMuted,
}));

export const MetricValue = styled('span')(() => ({
  fontWeight: 600,
  color: protoColors.textPrimary,
  textAlign: 'right',
}));

export const Alert = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  fontSize: '12.5px',
  color: protoColors.danger,
  backgroundColor: `${protoColors.danger}12`,
  borderRadius: '8px',
  padding: '6px 10px',
}));
